export const validPlan = ["pro", "starter", "elite"];
export const validPlanType = ["monthly", "quarterly", "annually"];
export const planTypeMap = {
  monthly: 1,
  quarterly: 3,
  annually: 12,
};
